import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { TableBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Table.module.css';
interface TableProps {
  block: TableBlock;
  blockId: string;
}
const LAYOUT_TO_CLASS = {
  basic: styles.basic,
  comparison: styles.comparison,
  spec: styles.spec
} as const;
export function Table(t0) {
  const $ = _c(17);
  const {
    block,
    blockId
  } = t0;
  const layoutClass = LAYOUT_TO_CLASS[block.layout ?? "basic"];
  const t1 = block.id;
  const t2 = `${styles.table} ${layoutClass}`;
  let t3;
  if ($[0] !== block.caption) {
    t3 = block.caption && block.caption.length > 0 ? <caption className={styles.caption}><RichSegments segments={block.caption} /></caption> : null;
    $[0] = block.caption;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== block.headers) {
    t4 = block.headers.length > 0 ? <thead><tr>{block.headers.map(_temp)}</tr></thead> : null;
    $[2] = block.headers;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== block.rows) {
    t5 = block.rows.map(_temp3);
    $[4] = block.rows;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <tbody>{t5}</tbody>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== block.id || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <table id={t1} className={t2}>{t3}{t4}{t6}</table>;
    $[8] = block.id;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== blockId || $[15] !== t7) {
    t8 = <div className={styles.scroll} data-cms-block-id={blockId} data-cms-field="table">{t7}</div>;
    $[14] = blockId;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp3(row, rowIdx) {
  return <tr key={rowIdx}>{row.map(_temp2)}</tr>;
}
function _temp2(cellSegments_0, cellIdx) {
  return <td key={cellIdx}><RichSegments segments={cellSegments_0} /></td>;
}
function _temp(cellSegments, idx) {
  return <th key={idx} scope="col"><RichSegments segments={cellSegments} /></th>;
}